import { HQ_USER_TYPE, HQ_COMPANY_TYPE, HQ_ROLE_TYPE } from '../constants/hq-types';

const enhanceEntityObject = (entity, oxygenType) => Object.assign({}, entity, { oxygenType });

export const buildOxygenObjects = oxygen => {
  const { users, companies, roles } = oxygen;

  // We only handle used roles (used = a user in the project is assigned to them)
  let usedRoles = [];
  users.forEach(user => {
    usedRoles = usedRoles.concat(user.roles.map(role => role.oxygenId));
  });

  return {
    users: users.reduce((result, value) => {
      const user = enhanceEntityObject(value, HQ_USER_TYPE);
      result[user.oxygenId] = user;
      return result;
    }, {}),
    companies: companies.reduce((result, value) => {
      const company = enhanceEntityObject(value, HQ_COMPANY_TYPE);
      result[company.oxygenId] = company;
      return result;
    }, {}),
    roles: roles.reduce((result, value) => {
      const role = enhanceEntityObject(value, HQ_ROLE_TYPE);

      // Mark role as in project in case needed, this will be used in our selectors for filtering
      if (usedRoles.includes(value.oxygenId)) {
        role.isInProject = true;
      }

      result[role.oxygenId] = role;

      return result;
    }, {}),
  };
};
